import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import clsx from 'clsx';

const styles = theme => ({
  featureGroup: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: 8,
  },
  checkmarkIcon: {
    width: 20,
    color: '#45A358',
    marginRight: 8,
  },
  feature: {
    marginTop: 5,
  },
  featureAdditional: {
    fontSize: 16,
    color: '#72848e',
    display: 'block',
    maxWidth: 256,
  },
  activeFeatureAdditional: {
    color: '#35383a',
  },
});

function PricingCardFeature({ mainText, additionalText, classes, isActive }) {
  return (
    <div className={classes.featureGroup}>
      <CheckIcon className={classes.checkmarkIcon} />
      <Typography className={classes.feature}>
        {mainText}
        {additionalText && (
          <span className={clsx(classes.featureAdditional, isActive && classes.activeFeatureAdditional)}>
            {additionalText}
          </span>
        )}
      </Typography>
    </div>
  );
}

export default withStyles(styles)(PricingCardFeature);
